export default "__VITE_ASSET__CugDm5Ad__"